import { cloneDeep } from 'es-toolkit';

export const hasDuplicates = (a: unknown[]) => {
  return new Set(a).size !== a.length;
};

export const arrayMove = (arr: unknown[], fromIndex: number, toIndex: number): unknown[] => {
  if (!Array.isArray(arr) || arr.length === 0 || fromIndex === toIndex) {
    return arr;
  }
  const localArray = cloneDeep(arr);
  const element = localArray[fromIndex];
  localArray.splice(fromIndex, 1);
  localArray.splice(toIndex, 0, element);
  return localArray;
};
